//Add hover effect on top / sublevel menus
document.addEventListener("DOMContentLoaded", function () {
  const topLevelMenus = document.querySelectorAll(".leveltop_jj > li");

  topLevelMenus.forEach((menu) => {
    menu.addEventListener("mouseenter", function () {
      // Get the handle of the hovered menu item
      const handle = this.getAttribute("handle");

      // Hide all submenus and remove 'selected' from all menus and the special class from specific parent
      topLevelMenus.forEach((otherMenu) => {
        // Remove 'selected' class from all other menus
        otherMenu.classList.remove("selected");
        const otherHandle = otherMenu.getAttribute("handle");
        const allSubmenus = document.querySelectorAll("." + otherHandle);
        allSubmenus.forEach((submenu) => {
          submenu.style.display = "none"; // Hide all submenus
        });

        // Remove the "bls-item-active" class from specific parent elements
        const specialParents = document.querySelectorAll(
          "." + otherHandle + " .view-all"
        );
        specialParents.forEach((sp) => {
          const parent = sp.parentElement;
          parent.classList.add("bls-item-active");
        });
      });

      // Add 'selected' to the current menu
      this.classList.add("selected");

      // Find and display submenus associated with the current handle
      const matchedSubmenus = document.querySelectorAll("." + handle);
      matchedSubmenus.forEach((submenu) => {
        submenu.style.display = "inline-block";
      });
    });
  });
});

//Show / Hide description on Collection pages
function toggleDescription() {
  const description = document.getElementById("description-remaining");
  const button = document.querySelector("button");

  if (
    description.style.display === "none" ||
    description.style.display === ""
  ) {
    description.style.display = "block";
    button.textContent = "Read Less";
  } else {
    description.style.display = "none";
    button.textContent = "Read More";
  }
}
$(document).on("click", "div[data-action='toggle-nav']", function () {
  $(".dl-menu").addClass("dl-menuopen");
  $("div#dl-menu").addClass("active");
});
$(document).on("click", ".close_mobil_mnu .close-menu", function () {
  $(".dl-menu").removeClass("dl-menuopen");
  $("div#dl-menu").removeClass("active");
});

$(function () {
  $("#dl-menu").dlmenu({
    animationClasses: {
      classin: "dl-animate-in-2",
      classout: "dl-animate-out-2",
    },
  });
});

setTimeout(function () {
  var getTitleGroup = $(".bls__product-title").attr("color");
  $(".selected_color_name").text(getTitleGroup);
}, 2000);

//Load States on minicart.
$(document).on("click", ".mini_cart_addon_btn.shipping", function () {
  let e = document.getElementById("address_country"),
    t = document.getElementById("address_province");
  if (e && t) {
    new Shopify.CountryProvinceSelector("address_country", "address_province", {
      hideElement: "address_province_container",
    });
  }
});

$(document).on("click", ".bls__addon-actions .btn-save", function (e) {
  console.log("Estimate Clicked");
  var e = {};
  e.zip = document.querySelector("#AddressZip").value || "";
  e.country = document.querySelector("#address_country").value || "";
  e.province = document.querySelector("#address_province").value || "";

  fetch(
    `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${e.zip}&shipping_address%5Bcountry%5D=${e.country}&shipping_address%5Bprovince%5D=${e.province}`
  )
    .then((e) => e.text())
    .then((t) => {
      let n = document.querySelector(".bls__addon-message");
      for (var i of document.querySelectorAll(".bls__addon-message p"))
        i.remove();
      let o = JSON.parse(t);
      if (o && o.shipping_rates)
        if (o.shipping_rates.length > 0) {
          n.classList.remove("error", "warning"), n.classList.add("success");
          let t = document.createElement("p");
          (t.innerText = cartStrings.shipping_rate.replace(
            "{{address}}",
            e.zip + ", " + e.country + " " + e.province
          )),
            n.appendChild(t),
            o.shipping_rates.map((e) => {
              let t = document.createElement("p");
              (t.innerHTML =
                e.name +
                ": " +
                Shopify.formatMoney(e.price, cartStrings.money_format)),
                n.appendChild(t);
            });
        } else {
          n.classList.remove("error", "success"), n.classList.add("warning");
          let e = document.createElement("p");
          (e.innerText = cartStrings.no_shipping), n.appendChild(e);
        }
      else
        n.classList.remove("success", "warning"),
          n.classList.add("error"),
          Object.entries(o).map((e) => {
            let t = `${e[1][0]}`,
              i = document.createElement("p");
            (i.innerText = t), n.appendChild(i);
          });
    })
    .catch((e) => {
      throw e;
    });
});

$(document).on("click", ".bls__cart-addons.border-bottom > div", function () {
  var getDataId = $(this).attr("data-id");
  if (getDataId == "not") {
    var getDataId = "note";
  }
  $(".bls__addon").removeClass("is-open");
  $("#bls__" + getDataId).addClass("is-open");
  $(".bls__canvas-right").addClass("addons-open");
});
$(document).on("click", "button.btn-cancel.btn-secondary", function () {
  $(".bls__addon").removeClass("is-open");
  $(".bls__canvas-right").removeClass("addons-open");
});

$(document).on("click", ".collection_color_click", function () {
  event.preventDefault();
  var collColorImg = $(this).attr("product-image");
  var collSwatchLink = $(this).attr("href");
  var collSwatchName = $(this).attr("title-color");
  $(this)
    .parents(".bls__product-item")
    .find(".bls__product-grid img")
    .attr("src", collColorImg);
  $(this)
    .parents(".bls__product-item")
    .find(".bls__product-grid img")
    .attr("srcset", collColorImg);
  $(this)
    .parents(".bls__product-item")
    .find(".bls__img-url")
    .attr("href", collSwatchLink);
  $(this)
    .parents(".bls__product-item")
    .find(".bls__product-name a")
    .attr("href", collSwatchLink);
  $(this).parents(".bls__product-item").find(".sub_title").text(collSwatchName);
});

if ($(".template-product #form-product-grouped").length < 1) {
  $("#product-form form").addClass("form-product-grouped");
}

$(document).on("click", "body #variant-radios", function () {
  var form = document.forms.namedItem("prod-form");
  var inputField = form.children.namedItem("product-id");
  var event = new Event("change", {
    bubbles: true,
    cancelable: true,
  });
  inputField.dispatchEvent(event);
});

document.addEventListener("DOMContentLoaded", function () {
  var getFirstLevelMenu = $(".leveltop_jj").clone();
  $(getFirstLevelMenu).appendTo($(".dl-menu"));
  $(".dl-menu .leveltop_jj .level0").unwrap();

  $(".dl-menu li.level0").each(function () {
    var getHandleMenu = $(this).attr("handle");
    var getFirstLevelMenus = $(
      "#horizontal-menu-new li." + getHandleMenu
    ).clone();
    $(this).append(
      '<ul id="menu' + getHandleMenu + '" class="dl-submenu"></ul>'
    );
    $(this)
      .find("#menu" + getHandleMenu)
      .append($(getFirstLevelMenus));
    $(this).find(".subchildmenu").addClass("dl-submenu");
    $(".dl-menu .open-children-toggle").remove();
    $("#menu" + getHandleMenu + "> li").each(function (innerli) {
      var getEachlevel1Items = $(this).find(".submenu .type_link").length;
      //console.log("getEachlevel1Items"+getEachlevel1Items);
      if (getEachlevel1Items < 1) {
        $(this).find(".submenu").remove();
      } else {
        $(this).find("link").remove();
        $(this).append(
          '<ul id="menu-level1-' + getHandleMenu + '" class="dl-submenu"></ul>'
        );
        var getSecondLevelMenus = $(this).find(".bls-menu-item").clone();
        $(this).find(".submenu").remove();
        $(this)
          .find("#menu-level1-" + getHandleMenu)
          .append($(getSecondLevelMenus));
        $(this)
          .find(".bls-menu-item")
          .each(function () {
            $(this).replaceWith("<li>" + $(this).html() + "</li>");
          });
        $(this)
          .find(".bls__menu_banner-heading")
          .each(function () {
            $(this).replaceWith($(this).text());
          });
        $(this)
          .find(".bls-banner-inner")
          .each(function () {
            /*$(this).find('.bls__menu_banner-heading').unwrap();
                $(this).replaceWith( "<ul class='dl-submenu'><li>" + $(this).html() + "</li></ul>" );*/
            var getImageColl = $(this).find("img");
            $(this).prev().addClass("removeArrow");
            $(getImageColl).appendTo($(this).prev());
          });
      }
    });
  });

  $(document).on("click", ".brands_list_items_ul li a", function () {
    var getCoutry = $(this).attr("href");
    $(".brands_list_items_ul li a").removeClass("selectedcountry");
    $(this).addClass("selectedcountry");
    if (getCoutry == "#AU") {
      $("li.list-brand").hide();
      $('li.list-brand[country="AU"]').show();
    } else if (getCoutry == "#EU") {
      $("li.list-brand").hide();
      $('li.list-brand[country="EU"]').show();
    } else if (getCoutry == "#USA") {
      $("li.list-brand").hide();
      $('li.list-brand[country="USA"]').show();
    } else {
      $("li.list-brand").show();
    }
    $(".right_brand div.letter").each(function () {
      $(this).show();
      var getCounts = $(this).find("li.list-brand").length;
      var getSelectedCount = $(".brands_list_items_ul a.selectedcountry").attr(
        "href"
      );
      if (getSelectedCount == "#ALL") {
        $(this).show();
      } else {
        var hiddenH5 = $(this).find('li[style="display: none;"]').length;
        if (hiddenH5 == getCounts) {
          $(this).hide();
        }
      }
    });
  });

  $(".tab_pdp_bottom").wrapAll('<div class="tabs_pdp tabs"></div>');
  $('<ul id="tabs-nav"></ul>').prependTo(".tabs_pdp");

  $(".tab_pdp_bottom").each(function () {
    var getTabName = $(this)
      .find(".bls__section-header h2.bls__section-heading")
      .text()
      .trim();
    var tabHandle = getTabName.replace(/\s+/g, "-").toLowerCase();
    $(
      "<li class='" +
        tabHandle +
        "'><a href='#" +
        tabHandle +
        "'>" +
        getTabName +
        "</a><li>"
    ).appendTo($("#tabs-nav"));
  });
  $("#tabs-nav li").eq(1).remove();
  $("#tabs-nav li").eq(2).remove();

  // Show the first tab and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    if (activeTab == "#recently-viewed") {
      $(".pdp_recently").fadeIn();
    } else if (activeTab == "#you-may-also-like") {
      $(".pdp_recommendations").fadeIn();
    } else {
      return false;
    }
  });

  $("body.template-product .products-carousel").appendTo($(".add_on_wrapper"));

  setTimeout(function () {
    var checkATConPdp = $(".product-form__submit span.hidden-loading")
      .text()
      .trim();
    console.log("checkATConPdp" + checkATConPdp);
    if (checkATConPdp == "Sold out") {
      $(".size_drop_wrapper").addClass("sold_out_atc");
    }
  }, 1000);

  $(".collection_color_click").click(function (event) {
    event.preventDefault();
    var collColorImg = $(this).attr("product-image");
    var collSwatchLink = $(this).attr("href");
    $(this)
      .parents(".bls__product-item")
      .find(".bls__product-grid img")
      .attr("src", collColorImg);
    $(this)
      .parents(".bls__product-item")
      .find(".bls__product-grid img")
      .attr("srcset", collColorImg);
    $(this)
      .parents(".bls__product-item")
      .find(".bls__img-url")
      .attr("href", collSwatchLink);
    $(this)
      .parents(".bls__product-item")
      .find(".bls__product-name a")
      .attr("href", collSwatchLink);
  });

  var getTitleGroup = $(".bls__product-title").attr("color");
  //alert("getTitleGroup"+getTitleGroup);
  setTimeout(function () {
    var getTitleGroup = $(".bls__product-title").attr("color");
    $(".selected_color_name").text(getTitleGroup);
  }, 2000);

  $("#bls__product-group .product-group-image-item").click(function () {
    var getTitleGroup = $("#bls__product-group .product-group-image-item").attr(
      "title"
    );
    $(".selected_color_name").text(getTitleGroup);
  });

  $(".custom_dropdown_size legend.form__label").click(function () {
    $(this).parent().addClass("active");
    $("body").addClass("active");
    $(this).find(".size_drop_wrapper").show();
  });
  $(".custom_dropdown_size .size_drop_wrapper .bls__option-swatch").click(
    function () {
      $(this).parent().parent().removeClass("active");
      $("body").removeClass("active");
      $(this).parent().hide();
    }
  );

  /* $('.template-product').on('click', function() {
    console.log("Id"+$(this).attr('class'));
    if($(this).attr('class') == 'template-product full-width-layout product-images-style-radius sticky-addtocart-show')
    {
      $('.custom_dropdown_size').addClass('active');
      $('.size_drop_wrapper').show();
    }else{
      $('.custom_dropdown_size').removeClass('active');
      $('.size_drop_wrapper').hide();
    }
  });*/

  $(document).on("click", function (event) {
    console.log(event.target.className);
    var getClassName = event.target.className;
    if (
      getClassName == "swatch-selected-value heading-weight heading-color" ||
      getClassName == "form__label mb-8" ||
      getClassName == "swatch-attribute-label" ||
      getClassName == "icon-chevron-down"
    ) {
      console.log("Yes");
    } else {
      console.log("No");
      $(".custom_dropdown_size").removeClass("active");
      $(".size_drop_wrapper").hide();
    }
  });

  /*$('body').on('click', function() {
    setTimeout(function() { 
        console.log("Id"+$(this).attr('class'));
        if($('body').hasClass('active'))
        {
          $('.custom_dropdown_size').removeClass('active');
          $('.size_drop_wrapper').hide();
        }else{
          $('.custom_dropdown_size').addClass('active');
          $('.size_drop_wrapper').show();
        }
    }, 200);
    
  });*/

  $(".bls__option-swatch").click(function () {
    if ($(".product-form button.product-form__submit").attr("disabled")) {
      console.log("Sold Out");
      document.querySelector(".bls__product-dynamic-checkout").style.display =
        "none";
    } else {
      console.log("ATC");
      document.querySelector(".bls__product-dynamic-checkout").style.display =
        "block";
    }
  });

  if ($(".product-form button.product-form__submit").attr("disabled")) {
    console.log("Sold Out");
    document.querySelector(".bls__product-dynamic-checkout").style.display =
      "none";
  } else {
    console.log("ATC");
  }
  //Hides / Shows product Pickup option text on Pre-Order / Made to Order of Product Pages
  function handleMutation(mutationsList, observer) {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList.contains("timesact-preorder-description")
          ) {
            // Apply CSS when the element is added
            console.log("Hide it");
            document.querySelector(
              ".bls__product-dynamic-checkout"
            ).style.display = "block";

            document.querySelector(
              ".product__pickup-availabilities"
            ).style.display = "none";
          }
        });

        mutation.removedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList.contains("timesact-preorder-description")
          ) {
            // Remove CSS when the element is removed
            console.log("Show it");
            document.querySelector(
              ".bls__product-dynamic-checkout"
            ).style.display = "none";
            document.querySelector(
              ".product__pickup-availabilities"
            ).style.display = "";
          }
        });
      }
    });
  }

  const observerConfig = {
    childList: true,
    subtree: true, // Observe all descendants, not just direct children
  };

  const observer = new MutationObserver(handleMutation);
  const parentElement = document.body;

  observer.observe(parentElement, observerConfig);

  /* End Hide Show option */

  // ISO 2-letter code to full country name mapping for top 20 western countries
  const countryMapping = {
    AU: "Australia",
    AT: "Austria",
    BE: "Belgium",
    BN: "Brunei",
    CA: "Canada",
    CN: "China",
    HR: "Croatia",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    EE: "Estonia",
    FI: "Finland",
    FR: "France",
    DE: "Germany",
    GR: "Greece",
    HK: "Hong Kong SAR",
    HU: "Hungary",
    IT: "Italy",
    JP: "Japan",
    MO: "Macau SAR",
    MY: "Malaysia",
    MT: "Malta",
    NL: "Netherlands",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NO: "Norway",
    PE: "Peru",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    SA: "Saudi Arabia",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    ZA: "South Africa",
    KR: "South Korea",
    ES: "Spain",
    SE: "Sweden",
    CH: "Switzerland",
    TH: "Thailand",
    GB: "United Kingdom",
    AE: "United Arab Emirates",
    US: "United States",
    VN: "Vietnam",
  };

  function getCountryNameFromISO(isoCode) {
    return countryMapping[isoCode] || null;
  }

  function updateCountryAndProvinceFromIP() {
    fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => {
        const fullCountryName = getCountryNameFromISO(data.country);
        if (fullCountryName) {
          const selectCountry = document.getElementById("address_country");
          const selectProvince = document.getElementById("address_province");

          selectCountry.value = fullCountryName;
          selectCountry.dispatchEvent(new Event("change"));

          // This loop is to find a matching region and update it.
          // Once found, it will exit the loop for efficiency.
          for (let option of selectProvince.options) {
            if (option.value === data.region) {
              selectProvince.value = data.region;
              selectProvince.dispatchEvent(new Event("change"));
              break;
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching IP info:", error);
      });
  }

  if (window.location.pathname === "/cart") {
    updateCountryAndProvinceFromIP();
  }

  function observeButtonAddition() {
    const config = { childList: true, subtree: true };
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          const button = document.querySelector(
            ".mini_cart_addon_btn.shipping"
          );
          if (button) {
            observer.disconnect();
            button.addEventListener("click", updateCountryAndProvinceFromIP);
          }
        }
      }
    });

    observer.observe(document.body, config);
  }

  const button = document.querySelector(".mini_cart_addon_btn.shipping");
  if (button) {
    button.addEventListener("click", updateCountryAndProvinceFromIP);
  } else {
    const addToCartButton = document.querySelector(".product-form__submit");
    addToCartButton.addEventListener("click", observeButtonAddition);
  }
});
